import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar-notification',
  templateUrl: './avatar-notification.component.html',
  styleUrls: ['./avatar-notification.component.scss']
})
export class AvatarNotificationComponent {
  @Input() name: string = '';
  @Input() color: string = '#25292e';

  public text: string = '';

  ngOnInit(): void {
    if (!this.name) {
      this.text = 'N/A';
      return;
    }

    const words = this.name.split(' ');

    if (words.length > 1) {
      this.text = words[0][0].toUpperCase() + words[1][0].toUpperCase();
    } else if (words.length === 1) {
      this.text = words[0][0].toUpperCase();
    } else {
      this.text = '';
    }
  }
}
